import { Box, Container, SxProps, useMediaQuery, useTheme } from '@mui/material'
import { FC, useEffect } from 'react'
import { Outlet, useLocation, useNavigate, useNavigation } from 'react-router'
import { useDispatch } from 'react-redux'
import { AppDispatch } from '../../store'
import { TestStripHeader } from '../Header'

import { WaterInfoDrawer } from '../WaterInfoDrawer'
import { TestStripSummaryModal } from '../Modals/TestStripSummaryModal'
import { VerifySteps } from '../../views/Verify'
import { useVerificationGuard } from '../../hooks/auth/useVerificationGuard'
import { UserActions } from '../../store/User'
import { StorageKeys } from '../../store/Verification'

interface MainProps {
  sx?: SxProps
}

export const TestStripLayout: FC<MainProps> = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const dispatch = useDispatch<AppDispatch>()
  const isVerified = useVerificationGuard()

  // Fetch user profile so child screens (e.g. StripVersionDetection) have access to user._id
  useEffect(() => {
    if (isVerified) {
      const token = localStorage.getItem(StorageKeys.TOKEN)
      let email: string | null = null

      if (token) {
        try {
          const body = JSON.parse(atob(token.split('.')[1]))
          email = body.email as string
        } catch {
          // malformed token — fall through to verified_email check
        }
      }

      if (!email) {
        email = localStorage.getItem(StorageKeys.VERIFIED_EMAIL)
      }

      if (email) {
        dispatch(UserActions.fetchUserAsync({ email }))
      }
    }
  }, [isVerified, dispatch])

  useEffect(() => {
    if (!isVerified) {
      navigate('/test-strip/email')
    } else if (location.pathname === '/test-strip' || location.pathname === '/test-strip/') {
      navigate('/test-strip/data')
    }
  }, [isVerified])
  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection:'column',
        maxHeight: '100vh',

      }}
    >
      <TestStripHeader />
      <Container maxWidth="lg" sx={{flex:1}}>
      <VerifySteps/>
      <Box sx={{
        height: 'calc(100% - 120px)',
        display:'flex',

        justifyContent: 'center'}}>
        <Outlet />
      </Box>
      </Container>


      <TestStripSummaryModal />
    </Box>
  )
}
